import React, { memo } from 'react';
import classes from './headerMenu.css';
import parse_html from '@magento/pagebuilder/lib/helper';
import BBLink from "../BBLink";
import { useIntl } from "react-intl";
export var getSeoAttributeTitle = (text, formatMessage) => {
  return text && formatMessage({
    id: "headerMenu.shopFromStokes",
    defaultMessage: "Shop {text} from Stokes"
  }, {
    text
  });
};
var HeaderMenu = _ref => {
  var {
    left = [],
    right = [],
    actions = [],
    publicity = [],
    setShowNav,
    setInnerNavBar
  } = _ref;
  var {
    formatMessage
  } = useIntl();
  if ((!left || !left.length) && (!right || !right.length)) {
    return null;
  }
  var menuNodes = [];

  //separating nodes per title (so title always starts first)
  [...left, ...right].forEach(item => {
    if (item.classes === "title" || !menuNodes[menuNodes.length - 1]) {
      menuNodes.push([]);
    }
    if (item.is_active) {
      menuNodes[menuNodes.length - 1].push(item);
    }
  });
  return /*#__PURE__*/React.createElement("div", {
    className: classes.outerContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.innerPublicityMenu
  }, publicity && publicity.map(item => {
    if (!item.is_active) {
      return null;
    }
    if (item.image_path) {
      return /*#__PURE__*/React.createElement("img", {
        key: item.name + item.url_path,
        className: " ".concat(classes[item.classes]),
        src: item.image_path,
        alt: item.name
      });
    }
    return /*#__PURE__*/React.createElement(BBLink, {
      key: item.name + item.url_path,
      onClick: () => {
        setInnerNavBar();
        setShowNav();
      },
      to: '/' + item.url_path,
      className: "".concat(classes.item, " ").concat(classes[item.classes])
    }, parse_html(item.name));
  }), actions && actions.map(item => {
    return item.is_active ? /*#__PURE__*/React.createElement(BBLink, {
      key: item.name + item.url_path,
      onClick: () => {
        setInnerNavBar();
        setShowNav();
      },
      to: '/' + item.url_path,
      className: "".concat(classes.item, " ").concat(classes[item.classes])
    }, parse_html(item.name)) : null;
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.innerMenu
  }, menuNodes.map((items, index) => {
    if (!items || !items.length) return null;
    return /*#__PURE__*/React.createElement("div", {
      key: 'items-menu-' + index,
      className: classes.column
    }, items.map(item => {
      var text = parse_html(item.name);
      return /*#__PURE__*/React.createElement(BBLink, {
        key: text + item.url_path,
        onClick: () => {
          setInnerNavBar();
          setShowNav();
        },
        title: getSeoAttributeTitle(text, formatMessage),
        to: '/' + item.url_path,
        className: "".concat(classes.item, " ").concat(classes[item.classes] || classes.link)
      }, text);
    }));
  })));
};
export default memo(HeaderMenu);